'use strict';

import { addClassToElement } from '@jspartials/class-list-utils';

const prepend = ($parent, $newChild) => {
  $parent.insertBefore($newChild, $parent.firstChild);
};

const insertSiblingBefore = ($elem, $newSibling) => {
  $elem.parentNode.insertBefore($newSibling, $elem);
};

const insertSiblingAfter = ($elem, $newSibling) => {
  $elem.parentNode.insertBefore($newSibling, $elem.nextSibling);
};

const appendElementContent = ($elem, content) => {
  if (typeof content === 'string') {
    if (content) {
      $elem.innerHTML = content;
    }
  } else {
    $elem.appendChild(content);
  }
};

const setAttributes = ($elem, attributes) => {
  attributes.forEach((attr) => {
    $elem.setAttribute(attr.name, attr.value);
  });
};

const createElement = ({
  tag,
  content = '',
  classes = [],
  attributes = []
}) => {
  if (!tag) {
    return null;
  }

  const $newElement = document.createElement(tag);

  classes.forEach((singleClass) => {
    addClassToElement($newElement, singleClass);
  });

  appendElementContent($newElement, content);

  setAttributes($newElement, attributes);

  return $newElement;
};

const serializeForm = ($form) => {
  return new URLSearchParams(new FormData($form)).toString();
};

const multipleEventsListeners = (elem, events, func) => {
  events.split(' ').forEach((e) => elem.addEventListener(e, func, true));
};

const listenDOMEvent = ($elem, eventName = '', callback = null) => {
  if ($elem && eventName && callback) {
    $elem.addEventListener(eventName, callback);
  }
};

const dispatchCustomEvent = (eventName = '', detail = {}) => {
  document.dispatchEvent(new CustomEvent(eventName, { detail }));
};

/**
 * Returns a modified callback function that calls the
 * initial callback function only if the target element matches the given selector
 *
 * @param {string} selector
 * @param {function} callback
 */
// function getConditionalCallback(selector, callback) {
//   return function(e) {
//     if (e.target && e.target.matches(selector)) {
//       e.delegatedTarget = e.target;
//       callback.apply(this, arguments);
//       return;
//     }
//     // Not clicked directly, check bubble path
//     var path = event.path || (event.composedPath && event.composedPath());
//     if (!path) return;
//     for (var i = 0; i < path.length; ++i) {
//       var el = path[i];
//       if (el.matches(selector)) {
//         // Call callback for all elements on the path that match the selector
//         e.delegatedTarget = el;
//         callback.apply(this, arguments);
//       }
//       // We reached parent node, stop
//       if (el === e.currentTarget) {
//         return;
//       }
//     }
//   };
// }

/**
 *
 *
 * @param {Element} rootElement The root element to add the linster too.
 * @param {string} eventType The event type to listen for.
 * @param {string} selector The selector that should match the dynamic elements.
 * @param {function} callback The function to call when an event occurs on the given selector.
 * @param {boolean|object} options Passed as the regular `options` parameter to the addEventListener function
 *                                 Set to `true` to use capture.
 *                                 Usually used as an object to add the listener as `passive`
 */
// const addDynamicEventListener = (rootElement, eventType, selector, callback, options) => rootElement.addEventListener(
//   eventType,
//   getConditionalCallback(selector, callback),
//   options
// );

export {
  prepend,
  createElement,
  insertSiblingBefore,
  insertSiblingAfter,
  serializeForm,
  setAttributes,
  appendElementContent,
  multipleEventsListeners,
  listenDOMEvent,
  dispatchCustomEvent
};
